import { NextResponse } from "next/server";
import type { NextRequest } from "next/server";

// Define public routes that don't require authentication
const publicRoutes = ["/login"];

// Cookie names for authentication check
const TOKEN_COOKIE_NAME = "access_token";
const ACCESS_TOKEN_COOKIE = "accessToken"; // Legacy support

export function proxy(request: NextRequest) {
  const { pathname } = request.nextUrl;

  // Check if the current path is a public route
  const isPublicRoute = publicRoutes.some((route) =>
    pathname.startsWith(route),
  );

  // Check for access token cookie (JWT session-based)
  // Check both new cookie name and legacy cookie name for backward compatibility
  const accessToken =
    request.cookies.get(TOKEN_COOKIE_NAME) ||
    request.cookies.get(ACCESS_TOKEN_COOKIE);

  const isAuthenticated = !!accessToken?.value;

  // If user is not authenticated and trying to access a protected route
  if (!isAuthenticated && !isPublicRoute) {
    // Redirect to login page
    const loginUrl = new URL("/login", request.url);
    // Add the original URL as a redirect parameter so we can redirect back after login
    loginUrl.searchParams.set("redirect", pathname);
    return NextResponse.redirect(loginUrl);
  }

  // If user is authenticated and trying to access login page, redirect to home
  if (isAuthenticated && pathname === "/login") {
    return NextResponse.redirect(new URL("/", request.url));
  }

  // Allow the request to proceed
  return NextResponse.next();
}

// Configure which routes the middleware should run on
export const config = {
  matcher: [
    /*
     * Match all request paths except for the ones starting with:
     * - api (API routes)
     * - _next/static (static files)
     * - _next/image (image optimization files)
     * - favicon.ico (favicon file)
     * - public files (public folder)
     */
    "/((?!api|_next/static|_next/image|favicon.ico|.*\\.(?:svg|png|jpg|jpeg|gif|webp)$).*)",
  ],
};
